import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ArViewerComponent } from './ar-viewer/ar-viewer.component';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { DelegaViewerComponent } from './delega-viewer/delega-viewer.component';
import { InfoDocenteComponent } from './info-docente/info-docente.component';
import { InfoRilevazioneComponent } from './info-rilevazione/info-rilevazione.component';
import { ProgressBarStudenteComponent } from './progress-bar-studente/progress-bar-studente.component';
import { RadarRilViewerComponent } from './radar-ril-viewer/radar-ril-viewer.component';
import { RecuperoViewerComponent } from './recupero-viewer/recupero-viewer.component';
import { RilFilterComponent } from './ril-filter/ril-filter.component';
import { RilViewerComponent } from './ril-viewer/ril-viewer.component';
//import { IonicSelectableModule } from 'ionic-selectable';
import { QrcodeViewerComponent } from './qrcode-viewer.component';
import { RecuperoEditorComponent } from './recupero-editor/recupero-editor.component';
import { IonicSelectableComponent } from 'ionic-selectable';
import { InfoIdoneitaComponent } from './info-idoneita/info-idoneita.component';


@NgModule({
  declarations: [
    AutoCompleteComponent,
    RilViewerComponent,
    ArViewerComponent,
    ProgressBarStudenteComponent,
    RadarRilViewerComponent,
    DelegaViewerComponent,
    InfoDocenteComponent,
    InfoRilevazioneComponent,
    RecuperoViewerComponent,
    RecuperoEditorComponent,
    RilFilterComponent,
    InfoIdoneitaComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    QrcodeViewerComponent,
    IonicSelectableComponent,
    TranslateModule.forChild()
  ],
  exports: [
    AutoCompleteComponent,
    RilViewerComponent,
    ArViewerComponent,
    ProgressBarStudenteComponent,
    RadarRilViewerComponent,
    DelegaViewerComponent,
    InfoDocenteComponent,
    InfoRilevazioneComponent,
    RecuperoViewerComponent,
    RecuperoEditorComponent,
    RilFilterComponent,
    InfoIdoneitaComponent
    //QrcodeViewerComponent
  ]
})
export class SharedModule { }
